import React from 'react';

import CLocalizedText from '../../../components/CLocalizedText';
import CPageModule from '../../../components/CPageModule';
import I18nButton from '../../../components/I18nButton';
import XDButton from '../../../components/buttons/XDButton';

interface Props {
  onAccept: () => void;
}

export default function CMultifundFactsheetTerms(props: Props) {
  return (
    <CPageModule style={{ paddingTop: 0, paddingBottom: 0 }} fullWidth>
      <div className={'relative'}>
        <div>
          <CLocalizedText dictKey={'global.termsOfUse.text'} />
        </div>

        <div className={'absolute top-0 -right-2'}>
          <I18nButton />
        </div>
      </div>

      <div className={'flex gap-4 justify-end'}>
        <XDButton
          className={'flex-grow justify-center py-4 bg-teal hover:bg-teal hover:bg-opacity-90 text-white font-bold'}
          onClick={props.onAccept}
        >
          <CLocalizedText dictKey={'globalTermsP13IAgree'} />
        </XDButton>
      </div>
    </CPageModule>
  );
}